import React, { useEffect, useState } from "react";
import Style from "./ProjectSummary.module.css";

const ProjectSummary = ({ name, initialValue, length, setSpecificState, isError, isSecondInputForm = false }) => {
  const [projectSummary, setProjectSummary] = useState("");
  const [maxLength, setMaxlength] = useState(length || "500");

  const handleInput = (event) => {
    const newValue = event.target.value;
    setProjectSummary(newValue);
    setSpecificState(newValue);

    setMaxlength(
      500 + (newValue.length - newValue.replace(/[\s\n]/g, "").length)
    );

    sessionStorage.setItem(name, newValue);
  };

  useEffect(() => {
    const savedValue = sessionStorage.getItem(name);

    if (savedValue) {
      setProjectSummary(savedValue);
      setSpecificState(savedValue);
    }
  }, [name, setSpecificState]);

  useEffect(() => {
    const savedValue = sessionStorage.getItem(name);

    if (savedValue) {
      setProjectSummary(savedValue);
      setSpecificState(savedValue);
    } else if (initialValue) {
      setProjectSummary(initialValue);
      setSpecificState(initialValue);
    }
  }, [initialValue, name, setSpecificState]);

  return (
    <div className={Style.ProjectSummaryContainer}>
      <textarea
        className={`${isSecondInputForm ? Style.SecondInputForm : Style.ProjectSummaryInput  } ${isError ? Style.Error : ""}`}
        maxLength={maxLength}
        type="text"
        onChange={handleInput}
        value={projectSummary}
        placeholder="opis projekta..."
      />
      <p style={{ alignSelf: "flex-end", marginRight: "10px" }}>
        {projectSummary.replace(/[\s\n]/g, "").length}
      </p>
    </div>
  );
};

export default ProjectSummary;
